module.exports = __webpack_public_path__ + "static/img/IMG_20170905_192803.1bd4eed0.jpg";